












































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { DcReminderInfo, Track } from 'frontend/types/daily-challenges';
import { defer } from 'frontend/utils/timing';
import { apiResolve } from 'frontend/router';
import { postData } from 'frontend/utils/ajax';
import { track } from 'frontend/utils/analytics';
import Button from 'frontend/components/Button.vue';

type ReminderSettingType = 'reminder' | 'snooze' | null;

@Component({
  computed: {
    ...mapGetters('dailyChallenges', ['reminder']),
  },
  components: {
    Button,
  },
})
export default class DailyChallengeReminder extends Vue {
  private reminder!: DcReminderInfo;

  private activeSetting: ReminderSettingType = null;
  private isDropdownActive = false;

  private trackIds: number[] = [];
  private sendTime = '';

  private snoozeDuration = 0;

  private saveInProgress = false;

  private closeDropdown() {
    this.isDropdownActive = false;
    window.removeEventListener('click', this.closeDropdown);
  }

  private toggleDropdown() {
    this.isDropdownActive = !this.isDropdownActive;
    if (this.isDropdownActive) {
      defer(() => window.addEventListener('click', this.closeDropdown));
    }
  }

  private closeSetting() {
    this.activeSetting = null;
  }

  private openSetting() {
    if (this.reminder.has_reminder && this.reminder.snooze_duration_days) {
      this.openSnoozeSetting();
    } else {
      this.openReminderSetting();
    }
  }

  private openSnoozeSetting() {
    this.activeSetting = 'snooze';
    this.isDropdownActive = false;
  }

  private openReminderSetting() {
    this.activeSetting = 'reminder';
    this.isDropdownActive = false;
  }

  private turnOffSnooze() {
    this.snoozeDuration = 0;
  }

  private get selectedTrackIds(): number[] {
    return this.reminder.tracks.filter(t => t.checked).map(t => t.id);
  }

  private get selectedReminderTime(): string {
    let time = '';
    const selectedTime = this.reminder.times.find(t => t.selected);
    if (selectedTime) {
      time = selectedTime.time;
    }
    return time;
  }

  private get hasReminder() {
    const hasTracks = this.trackIds.length > 0;
    const isSnoozed = this.snoozeDuration > 0;
    return hasTracks || isSnoozed;
  }

  private trackSnoozeDays = (snoozeDays: number) => {
    track('ui', {
      action: 'click',
      element_id: 'clicked_dailyproblems_snooze_reminders_save',
      snooze_days: snoozeDays,
    });
  };

  private get formUpdated() {
    if (this.activeSetting === 'reminder') {
      if (this.sendTime !== this.selectedReminderTime) {
        return true;
      }

      if (this.trackIds.length !== this.selectedTrackIds.length) {
        return true;
      }

      return JSON.stringify(this.trackIds.sort()) !== JSON.stringify(this.selectedTrackIds.sort());
    }

    if (this.activeSetting === 'snooze') {
      return Number(this.snoozeDuration) !== Number(this.reminder.snooze_duration_days || 0);
    }

    return false;
  }

  private get apiBase(): string {
    const apiParams = {
      name: 'api_dailyproblems_base',
    };
    return apiResolve(apiParams).href;
  }

  private async save(): Promise<void> {
    if (!this.formUpdated) {
      this.closeSetting();
      return;
    }

    let uri = this.apiBase;
    const data: any = {};
    this.saveInProgress = true;
    if (this.activeSetting === 'reminder') {
      uri += 'reminders/';
      data.send_time = this.sendTime;
      data.tracks = this.trackIds;
    } else if (this.activeSetting === 'snooze') {
      uri += 'reminders/snooze/';
      data.snooze_days = this.snoozeDuration;
    }
    const resp = await postData(uri, data);
    if (resp.success) {
      this.$store.commit('dailyChallenges/setReminder', resp.data.reminder_info);
      this.trackSnoozeDays(data.snooze_days);
      this.closeSetting();
    }
    this.saveInProgress = false;
  }

  private mounted() {
    if (this.reminder.snooze_duration_days) {
      this.snoozeDuration = this.reminder.snooze_duration_days;
    }
    if (this.reminder.has_reminder) {
      this.sendTime = this.selectedReminderTime;
      this.trackIds = this.selectedTrackIds;
    } else if (this.reminder.times.length) {
      this.sendTime = this.reminder.times[0].time;
    }
  }
}
